import { Checkbox } from "../components/ui/checkbox";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { Plus, Trash2 } from "lucide-react";

export const PUNTI_A = [["a1", "Pulizia moduli (lavaggio)"], ["a2", "Pulizia e controllo inverter e quadri"], ["a3", "Controllo generale dell'impianto"], ["a4", "Controllo visivo strutture di fissaggio"]];
export const PUNTI_B = [["b1", "Registro di produzione e immissione"], ["b2", "Dichiarazione annuale Accise/Dogane"], ["b3", "Reminder bollettino Officina Elettrica"],
  ["b4", "Reminder taratura contatore (3 anni)"], ["b5", "Reminder taratura protezione interfaccia (5 anni)"], ["b6", "Reminder fatturazione GSE"]];

export const isOn = (map, k) => (map || {})[k] !== false;

export function Spunta({ map, k, onToggle, label, testid, disabled = false }) {
  return (
    <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
      <Checkbox checked={isOn(map, k)} disabled={disabled} onCheckedChange={(v) => onToggle(k, !!v)} data-testid={testid} />
      <span className={isOn(map, k) ? "" : "line-through text-muted-foreground"}>{label}</span>
    </label>
  );
}

function Punti({ title, list, grp, form, setForm, disabled, prefix }) {
  const toggle = (k, v) => setForm((f) => ({ ...f, [grp]: { ...(f[grp] || {}), [k]: v } }));
  return (
    <div className={`rounded border p-3 space-y-2 ${disabled ? "opacity-50 pointer-events-none" : ""}`}>
      <div className="text-xs font-semibold">{title}</div>
      <div className="grid sm:grid-cols-2 gap-2">
        {list.map(([k, l]) => <Spunta key={k} map={form[grp]} k={k} label={l} onToggle={toggle} testid={`manut-${prefix}-${k}`} disabled={disabled} />)}
      </div>
    </div>
  );
}

export function ServiziAB({ form, setForm }) {
  const offA = !isOn(form.servizi, "A");
  const nInput = (k, label) => (
    <div>
      <Label className="text-xs">{label}</Label>
      <Input type="number" min={1} max={12} disabled={offA} value={form[k] ?? 1} onChange={(e) => setForm((f) => ({ ...f, [k]: Math.min(12, Number(e.target.value) || "") }))} data-testid={`manut-field-${k}`} />
    </div>
  );
  return (
    <section className="space-y-3">
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-bold">Servizi inclusi</div>
      <div className={`grid grid-cols-2 gap-3 ${isOn(form.servizi, "A") ? "" : "opacity-50 pointer-events-none"}`}>
        {nInput("n_visite", "Visite / giornate all'anno")}{nInput("n_lavaggi", "Lavaggi all'anno")}
      </div>
      <Punti title="A) Manutenzione ordinaria: punti compresi" list={PUNTI_A} grp="punti_a" form={form} setForm={setForm} disabled={!isOn(form.servizi, "A")} prefix="punto" />
      <Punti title="B) Officina Elettrica e GSE: punti compresi" list={PUNTI_B} grp="punti_b" form={form} setForm={setForm} disabled={!isOn(form.servizi, "B")} prefix="punto" />
    </section>
  );
}

export function ExtraList({ form, setForm }) {
  const ex = form.extra || [];
  const upd = (i, patch) => setForm((f) => ({ ...f, extra: (f.extra || []).map((x, j) => (j === i ? { ...x, ...patch } : x)) }));
  const add = () => setForm((f) => ({ ...f, extra: [...(f.extra || []), { descrizione: "", prezzo: "", tipo: "canone" }] }));
  const del = (i) => setForm((f) => ({ ...f, extra: (f.extra || []).filter((_, j) => j !== i) }));
  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-bold">Servizi aggiuntivi personalizzati</div>
        <Button size="sm" variant="outline" onClick={add} data-testid="manut-extra-add"><Plus className="h-3.5 w-3.5 mr-1" /> Aggiungi servizio</Button>
      </div>
      {ex.length === 0 && <div className="text-xs text-muted-foreground">Nessun servizio aggiuntivo.</div>}
      {ex.map((x, i) => (
        <div key={i} className="grid grid-cols-12 gap-2 items-center" data-testid={`manut-extra-${i}`}>
          <Input className="col-span-6" placeholder="Descrizione del servizio" value={x.descrizione} onChange={(e) => upd(i, { descrizione: e.target.value })} data-testid={`manut-extra-desc-${i}`} />
          <Input className="col-span-2" type="number" step="any" placeholder="€" value={x.prezzo ?? ""} onChange={(e) => upd(i, { prezzo: e.target.value })} data-testid={`manut-extra-prezzo-${i}`} />
          <select className="col-span-3 h-9 rounded border bg-background px-2 text-sm" value={x.tipo} onChange={(e) => upd(i, { tipo: e.target.value })} data-testid={`manut-extra-tipo-${i}`}>
            <option value="canone">Nel canone annuo</option><option value="richiesta">A richiesta</option>
          </select>
          <Button size="sm" variant="ghost" className="col-span-1" onClick={() => del(i)} data-testid={`manut-extra-del-${i}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
    </section>
  );
}
